import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogPortal,
} from "@/components/ui/dialog"
import { format } from "date-fns"
import { useApplicationSettings } from "@/api/applicationQueries"
import { Button } from "../ui/button"
import { TriangleAlert } from "lucide-react"

interface ApplicationDeadlineModalProps {
    open: boolean
    onOpenChange: (open: boolean) => void
}

export function ApplicationDeadlineModal({
    open,
    onOpenChange,
}: ApplicationDeadlineModalProps) {
    const { data: settings } = useApplicationSettings()

    const deadline = settings?.deadline?.toDate()
    const now = new Date()
    const hasDeadlinePassed = deadline && deadline < now
    const isAcceptingApplications = settings?.isAcceptingApplications

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogPortal>
                <DialogContent className="sm:max-w-[425px]">
                    <DialogHeader>
                        <DialogTitle
                            className={
                                hasDeadlinePassed || !isAcceptingApplications
                                    ? "text-red-500 flex items-center gap-2"
                                    : "text-yellow-500 flex items-center gap-2"
                            }
                        >
                            <TriangleAlert />
                            {hasDeadlinePassed || !isAcceptingApplications
                                ? "Submissions are closed"
                                : "Submissions Deadline"}
                        </DialogTitle>
                    </DialogHeader>
                    <div className="space-y-4">
                        {hasDeadlinePassed || !isAcceptingApplications ? (
                            <div className="space-y-2">
                                <DialogDescription>
                                    We are not accepting new submissions at the
                                    moment. You can still view, create or update
                                    your grant applications to be submitted
                                    later.
                                </DialogDescription>
                            </div>
                        ) : (
                            <div className="space-y-2">
                                <DialogDescription>
                                    Submissions are currently being accepted
                                    until:
                                </DialogDescription>
                                <div className="font-semibold">
                                    {deadline
                                        ? format(deadline, "PPP 'at' p")
                                        : "No deadline set"}
                                </div>
                                <div className="text-sm text-muted-foreground">
                                    Please ensure you submit your grant
                                    application before this deadline.
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="flex justify-end">
                        <Button onClick={() => onOpenChange(false)}>
                            Close
                        </Button>
                    </div>
                </DialogContent>
            </DialogPortal>
        </Dialog>
    )
}
